/**
@Class          : PageContact.js
@Date           : 2022-08-14
@Version        : 1.0
@Description    : 문의하기 페이지
 */
import React, { useState } from "react";
import { Block, BlockLabel, ContainerBox, FlexArea, ImgBox, ImgButton, TextBox, TextButton, TextInput } from "../commonLib/StyleMasterComp";
import { TextInputS, TextAreaS, DefaultButtonS } from "../commonLib/ServiceStyleMaster";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import Utils_ui from "../commonProj/Utils_ui";
import IcoPWViewOff from "../images/pageSignup/ico_eye1.png"
import IcoPWViewOn from "../images/pageSignup/ico_eye2.png"
import IcoPWCheck from "../images/pageSignup/ico_check.png"
import IcoCheck from "../images/pageSignup/ico_checkbox.png"
import { NSFetch, _API_URL } from "../NSCommon/middleware/NSCommunication";

let BoldSpan = styled.span`
    font-weight: 500;
`;

function PageContact(props)
{
    const navigate = useNavigate();

    const [isPWViewMode, setIsPWViewMode] = useState(false);                // 비밀번호 보기
    const [isConfirmPWViewMode, setIsConfirmPWViewMode] = useState(true);   // 비밀번호 확인
    const [isAgreeCheckbox, setIsAgreeCheckbox] = useState(false);           // 약관 동의 체크박스
    const [isActiveRequestBtn, setIsActiveRequestBtn] = useState(false);     // 가입신청 버튼 활성화

    const [strErrorText, setStrErrorText] = useState("이메일을 입력하지 않았습니다."); // 오류 문구
    const [iSecurityState, setISecurityState] = useState(0);                 // 보안 단계

    const [email, setEmail] = useState(null);
    const [pw, setPW] = useState(null);
    const [pw2, setPW2] = useState(null);

    const securityArr = [
        { state: "NONE", text: "", color: "" },
        { state: "LOW", text: "보안 단계 낮음", color: "#F34336" },
        { state: "HIGH", text: "보안 단계 높음", color: "#00C64F" }
    ]

    function checkEmail()
    {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }

    function checkPW(pw)
    {
        var passwd = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
        if (pw.value.match(passwd))
            setISecurityState(1);
        passwd = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
        if (pw.value.match(passwd))
            setISecurityState(2);

    }

    function emailChangeHandler(e)
    {
        var _em = e.target.value;
        setEmail(_em);

        validateAll(_em, pw, pw2);
    }

    function pw1ChangeHandler(e)
    {
        var _pw = e.target.value;
        setPW(_pw);
        checkPW(_pw);

        validateAll(email, _pw, pw2);
    }

    function pw2ChangeHandler(e)
    {
        var _pw = e.target.value;
        setPW2(_pw);

        validateAll(email, pw, _pw);
    }

    function validateAll(_email, _pw1, _pw2)
    {
        setIsActiveRequestBtn(false);

        console.log(_pw1, _pw2);

        if (!checkEmail(_email))
        {
            setStrErrorText("올바른 이메일을 입력해 주세요");
            return;
        }

        if (_pw1 != _pw2)
        {
            setStrErrorText("패스워드가 일치하지 않습니다.");
            return;
        }

        setStrErrorText("");

        setIsActiveRequestBtn(true);
    }

    /**
     * 회원 가입 폼 전송
     */
    function submit()
    {
        const _url = `${_API_URL}auth/signup`;
        const data = {
            userId: email,
            userPw: pw
        }

        function okFunc(res)
        {
            alert('회원 가입에 성공했습니다.');
            window.location.href = res.data.url;
        }

        function errFunc(res, code)
        {
            alert('회원 가입에 실패했습니다.')
        }

        NSFetch(_url, 'POST', data, okFunc, errFunc)
    }

    function move()
    {
        alert('클릭');
        navigate('/');
    }

    return (
        <ContainerBox>
            <FlexArea>
                <Block Width="440px" MinWidth="440px">
                    {/* 타이틀 */}
                    <Block MarginTop="55px">
                        <TextBox Height="65px" FontSize="52px" LineHeight="65px" FontWeight="400" TextAlign="center">
                            <BoldSpan>문의</BoldSpan> 하기
                        </TextBox>
                    </Block>

                    {/* 안내 문구 */}
                    <Block MarginTop="8px">
                        <TextBox Height="21px" FontSize="14px" FontColor="#F34336" TextAlign="center">
                            {strErrorText}
                        </TextBox>
                    </Block>

                    {/* 연락 받을 이메일 */}
                    <FlexArea FlexDirection="column" Position="relative" MarginTop="42px">
                        <TextBox Height="18px" LineHeight="18px" FontSize="14px">연락 받을 이메일 주소</TextBox>
                        <TextInputS MarginTop="8px"
                            autoComplete="off"
                            placeholder="이메일 주소를 입력하세요."
                            maxLength={20}
                            type="email" name="email"
                            onChange={emailChangeHandler}
                            // value={objValues.email || ""}
                            value={email || ""}
                            required
                        />
                    </FlexArea>

                    {/* 문의 내용 */}
                    <FlexArea FlexDirection="column" MarginTop="42px">
                        <TextBox Height="18px" LineHeight="18px" FontSize="14px">문의 내용</TextBox>
                        <TextAreaS Height="200px" MarginTop="8px"
                            autoComplete="off"
                            placeholder="최대 100자"
                            maxLength={100}
                            type="" name="text"
                            // onChange={}
                            // value={objValues.email || ""}
                            // value={email || ""}
                            required
                        />
                    </FlexArea>

                    {/* 확인 버튼 */}
                    <FlexArea>
                        <DefaultButtonS MarginTop="32px"
                            PointerEvents={isActiveRequestBtn ? "all" : "none"}
                            BackgroundColor={isActiveRequestBtn ? "#684DF1" : "#DEDEDE"}
                            onClick={submit}
                        >
                            보내기
                        </DefaultButtonS>
                    </FlexArea>

                </Block>
            </FlexArea>
        </ContainerBox>
    )
}

export default PageContact;